export const preventDefaultStopPropagationForHandler = (e: any) => {
  e.preventDefault();
  e.stopPropagation();
};

export const stopPropagationEvent = (e: any) => {
  e.stopPropagation();
};
